import React, { useMemo } from 'react';
import classNames from 'classnames';

import { Tag } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface TagItem {
  name: string;
  type?: string;
  link?: string;
  inverted?: boolean;
}

declare interface TagsProps {
  title?: string;
  items: TagItem[];
  overflowStartIndex?: number;
}

const Tags: React.FC<TagsProps> = (props) => {
  const {
    title,
    items,
    overflowStartIndex,
  } = props;

  // Only render tags which index < overflowStartIndex if
  // overflowStartIndex is used. Otherwise render the original list.
  const filteredItems = useMemo(() => {
    if (overflowStartIndex === undefined || overflowStartIndex === 0) {
      return items;
    }

    return items.slice(0, overflowStartIndex);
  }, [items, overflowStartIndex]);

  return (
    <div className="Tags">
      {title && (
        <h2 className="Tags__title label--regular">
          {title}
        </h2>
      )}

      <ul className="Tags__list">
        {filteredItems.map((item) => (
          <li key={`${item.name}:${item.type || ''}`}>
            <Tag
              stretchClickableArea={item.link !== undefined}
              link={item.link}
              target="_self"
              name={item.name}
              iconName={item.link ? 'chevron_right' : undefined}
              className={classNames(
                item.name.replaceAll(' ', '_'),
                item.type,
                {
                  'Tag--inverted': item.inverted,
                },
              )}
            />
          </li>
        ))}

        {(overflowStartIndex !== undefined && overflowStartIndex > 0 && items.length > 1) && (
          <li>
            <Tag
              name={`+${items.length - overflowStartIndex}`}
              className={classNames(
                items[0]?.type,
                {
                  'Tag--inverted': items[0]?.inverted,
                },
              )}
            />
          </li>
        )}
      </ul>
    </div>
  );
};

export default Tags;
